module.exports = __webpack_public_path__ + "static/media/image8.44390d36.png";